export default {
  title: 'Recenzia ta ne ajută cu adevărat ❤️',
  description: '{{name}} în {{store}} — apăsați doar o stea',
  buttons: {
    not_now: 'Nu acum',
    continue: 'Continuați',
  },
};
